export default "__VITE_ASSET__aaf5f182__"